import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "VoteUp.svg",
  "use": "VoteUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"VoteUp.svg\"><path d=\"M50.9948,35.9844H42V50a2,2,0,0,1-2,2H24a2,2,0,0,1-2-2V35.9844H12.9752a2,2,0,0,1-1.5685-3.2413l19.01-23.9845a2.0018,2.0018,0,0,1,3.137,0l19.01,23.9845A2,2,0,0,1,50.9948,35.9844Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol